<!--<div *ngIf="showFirstTimeMessage && !showLinkMessage">
  <hr />
  <h2 class="my-2 text-center">How Does This Thing Work?</h2>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <p>Since this is your first time take a look at the top right corner of the screen. The first menu item allows you to change your business channel. The second menu item provides access to your profile.</p>
    </div>
  </div>
</div>-->
<div *ngIf="showLinkMessage; else dashboard">
  <app-slider></app-slider>
  <hr />
  <h2 class="my-2 text-center">How Do I See My Agent Data?</h2>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <p>Your account profile is not yet linked to your Liberty Agent IDs.  In order to view your specific agent information – including policy details, commission data, and reports – please click the button below to perform a one-time link so that your login profile can be securely associated with your agent contracts.</p>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <a routerLink="/completeprofile" class="nav-link">
        <button class="btn btn-primary btn-block">
          Link my Agent IDs
        </button>
      </a>
    </div>
  </div>
</div>
<ng-template #dashboard>
  <app-dashboard></app-dashboard>
</ng-template>

<div style="padding-top:50px;">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <a class="btn" target="_blank" href="https://www.linkedin.com/company/liberty-bankers-life-insurance-company/">
        <i class="fa-2x fa-brands fa-linkedin" style="cursor: pointer; color: #39519f" ngbTooltip="Visit Liberty Bankers Insurance Group on LinkedIn" tooltipClass="lbig-tooltip"></i>
      </a>
      <a class="btn" target="_blank" href="https://www.facebook.com/libertybankersinsurancegroup">
        <i class="fa-2x fa-brands fa-facebook" style="cursor: pointer; color: #39519f" ngbTooltip="Visit Liberty Bankers Insurance Group on Facebook" tooltipClass="lbig-tooltip"></i>
      </a>
      <a class="btn" target="_blank" href="https://www.instagram.com/libertybankers">
        <i class="fa-2x fa-brands fa-instagram" style="cursor: pointer; color: #39519f" ngbTooltip="Visit Liberty Bankers Insurance Group on Instagram" tooltipClass="lbig-tooltip"></i>
      </a>
      <a class="btn" target="_blank" href="https://www.youtube.com/channel/UCuyTRlF-jUMTrgkNebW2P-g">
        <i class="fa-2x fa-brands fa-youtube" style="cursor: pointer; color: #39519f" ngbTooltip="Visit Liberty Bankers Insurance Group on YouTube" tooltipClass="lbig-tooltip"></i>
      </a>
    </div>
  </div>
</div>


